import { render, staticRenderFns } from "./CaptainComplaints.vue?vue&type=template&id=960dfbc8&scoped=true"
import script from "./CaptainComplaints.vue?vue&type=script&lang=js"
export * from "./CaptainComplaints.vue?vue&type=script&lang=js"
import style0 from "./CaptainComplaints.vue?vue&type=style&index=0&id=960dfbc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "960dfbc8",
  null
  
)

export default component.exports